<link href="https://fonts.googleapis.com/css?family=Gothic+A1" rel="stylesheet">
<!-- <ngx-toastr style="width: 100%; height: 100%; z-index: 50000;"></ngx-toastr> -->
<div class="container-fluid">
  <div class="header do-not-print">
    <div class="headerLeft navbar-section">
      <div *ngIf="isUserLoggedIn">
        <button id="menuBtn" mat-raised-button (click)="toggleSideBar()" class="btn btn-primary"><b>Menu</b></button>
        <button id="homeBtn" type="button" class="btn btn-link text-white" title="home"
                (click)="clickHome()">
          <i class="fa fa-home fa-2x" aria-hidden="true"></i>
        </button>

        @if(isUserLoggedIn && hasSelectedProject){
        <div class="project-label">
          Project: <span style="color: {{ currentColor }};"><mat-icon class="middle-align-icon">folder_open</mat-icon> <span class="activeProjectLabel">{{ activeProjectTitle }}</span> </span>
        </div>}
      </div>
    </div>
    <div class="navbar-section">
      <h1 class="text-center odp-title odp-md-title-text-size odp-xs-title-text-size">
        ODP Taxonomy {{ appTitle }}
      </h1>
    </div>
    <div class="headerRight text-right navbar-section">
       <span *ngIf="isUserLoggedIn" class="userName">User: <strong>{{fullName}}</strong></span>
       <span *ngIf="isUserLoggedIn && hasSelectedRole" class="userRole">Role: <strong>{{role}}</strong></span>
    </div>

  </div>
  <app-main-menu [openedSideBar]="openedSideBar" (sidebarClicked)="toggleSideBar($event)"></app-main-menu>
  <div class="">
    <div class="col-md-12 col-12" [@fadeAnimation]="activatedRoute">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
